import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Minus, Plus } from "lucide-react";

function QuantityStepper({ value, onChange }) {
  const [inputValue, setInputValue] = useState(value.toString());

  useEffect(() => {
    setInputValue(value.toString());
  }, [value]);

  const handleDecrement = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    const numValue = parseInt(inputValue, 10);

    if (!isNaN(numValue) && numValue >= 1) {
      onChange(numValue);
    } else if (!isNaN(numValue) && numValue >= 999) {
    } else {
      setInputValue(value.toString());
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="outline"
        size="icon"
        onClick={handleDecrement}
        disabled={value <= 1}
        className="h-9 w-9"
      >
        <Minus className="h-4 w-4" />
      </Button>
      <Input
        type="number"
        className="w-14 text-center h-9"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        min="1"
        max="999"
      />
      <Button
        variant="outline"
        size="icon"
        onClick={handleIncrement}
        className="h-9 w-9"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}

export default QuantityStepper;
